import { RemoteUploadFile } from '../../../data/usecases/upload-file/remote-upload-file'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeUploadFile = (uri: string) => new RemoteUploadFile(`/${uri}`, makeAxiosHttpClient())
